import { Box, Container, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Carousel } from "@atoms/Carousel";
import { Section } from "@atoms/Section";
import Text from "@ds/components/Text";
import type { TBaseContent, TVariantProps } from "../../type";
import { i18n } from "next-i18next";

const useStyles = makeStyles(() => ({
  mediaHome: {
    maxWidth: 426,
    height: 320,
    borderRadius: "24px",
    objectFit: "cover",
  },
}));

const ContainerVariants: React.FC<{ dataVariant: TVariantProps; productName: string }> = (
  props,
) => {
  const { dataVariant, productName } = props;
  const classes = useStyles();

  const lang = i18n?.language;

  const varianTitleEn = lang === "en" ? (dataVariant.length > 1 ? "Variants" : "Variant") : "";
  const varianTitleId = lang === "id" ? "Varian" : "";

  return (
    <Section
      variant="gray"
      title={varianTitleId + " " + productName + " " + varianTitleEn}
      maxWidth="full-width"
      paddingX="110px"
      sx={{ ".slick-dots": { bottom: "-50px" } }}
    >
      <Carousel settings={{ slidesToShow: 1, dots: true }}>
        {dataVariant?.map((el: TBaseContent, idx: number) => (
          <Box key={idx}>
            <Container maxWidth="lg" disableGutters>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                paddingX="3%"
                width="100%"
                spacing={1}
              >
                <Grid item md={6} lg={6} xl={5}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    flexWrap="wrap"
                    alignItems="flex-start"
                    textAlign="justify"
                    gap={2}
                  >
                    <Text variant="h1" weight="700">
                      {el.name}
                    </Text>
                    <Text weight="600">
                      <Box dangerouslySetInnerHTML={{ __html: el.description }} />
                    </Text>
                  </Box>
                </Grid>
                <Grid item md={5} lg={5} xl={5}>
                  <Box display="flex" justifyContent="flex-end">
                    <Box
                      component="img"
                      src={el.image.mediaPath}
                      alt={el.image.mediaName}
                      className={classes?.mediaHome}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </Box>
        ))}
      </Carousel>
    </Section>
  );
};

export default ContainerVariants;
